const DailyActivity = class DailyActivity {
    constructor() {
        this.isActive = false;
    }
};

export default DailyActivity;
